module.exports = __webpack_public_path__ + "static/media/logo.df29744a.svg";